export default __webpack_public_path__ + "a66ce5b876a1a9ff33865f9e21969bd4.png";